import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * This is a static react port of the cdc template 5 dot gov logo svg
 */

export default class DotGovIcon extends Component {

    render() {
        const { className } = this.props;
        return (
            <svg className={className} width="40" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_31_7)">
                    <path d="M36.5 20.91V22.27H35.15C35.1422 22.4566 35.0612 22.6325 34.9246 22.7598C34.7879 22.8871 34.6066 22.9554 34.42 22.95H18.23C18.0433 22.9554 17.8621 22.8871 17.7254 22.7598C17.5888 22.6325 17.5078 22.4566 17.5 22.27H16.14V20.91L26.32 16.84L36.5 20.91ZM36.5 34.48V35.84H16.14V34.48C16.1478 34.2934 16.2288 34.1174 16.3654 33.9902C16.5021 33.8629 16.6833 33.7946 16.87 33.8H35.77C35.9567 33.7946 36.1379 33.8629 36.2746 33.9902C36.4112 34.1174 36.4922 34.2934 36.5 34.48ZM21.57 23.62V31.76H22.93V23.62H25.64V31.76H27V23.62H29.71V31.76H31.07V23.62H33.78V31.76H34.41C34.5967 31.7546 34.7779 31.8229 34.9146 31.9502C35.0512 32.0775 35.1322 32.2534 35.14 32.44V33.12H17.5V32.45C17.5078 32.2634 17.5888 32.0875 17.7254 31.9602C17.8621 31.8329 18.0433 31.7646 18.23 31.77H18.86V23.62H21.57Z" fill="#007FAA" />
                    <path d="M27 53.12C41.3594 53.12 53 41.4794 53 27.12C53 12.7606 41.3594 1.12 27 1.12C12.6406 1.12 1 12.7606 1 27.12C1 41.4794 12.6406 53.12 27 53.12Z" stroke="#046B99" strokeMiterlimit="10" />
                </g>
                <defs>
                    <clipPath id="clip0_31_7">
                        <rect width="54" height="54" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        );
    }

}

DotGovIcon.propTypes = {
    className: PropTypes.string
}